import React from "react";
import classNames from "classnames";
import "@/Scss/Components/picture.scss";

/**
 * Example:
 * <Picture
 *     src={`/storage/img/image.png`}                 - required (Путь к изображению desktop)
 *     srcMobile={`/storage/img/image-mobile.png`}    - (Путь к изображению mobile)
 *     alt={`Изображение`}                            - required (Альтернативное название)
 *     title
 *     width
 *     height
 *     className={``}                                 - Имя класса для тега <picture />
 *     imageClassName={``}                            - Имя класса для тега <img />
 *     loading={`lazy`}
 *     withoutWebp                                    - Определяет, нужно ли менять расширение файла на ".webp"
 *     onClick
 * />
 * @param props
 * @returns {JSX.Element|null}
 * @constructor
 */
const Picture = (
    {
        src,
        srcMobile = "",
        alt,
        title,
        width = '',
        height = '',
        className = "",
        imageClassName = "",
        loading = "lazy",
        withoutWebp,
        onClick,
        draggable= true
    }
) => {
    if (!src || !alt) {
        // MODE - Это встроенная переменная Vite, она доступна всегда ("development" или "production")
        if (import.meta.env.MODE !== 'production') {
            console.warn(
                `<Picture /> requires both "src" and "alt" props. Received:`,
                {src, alt}
            );
        }
        return null;
    }

    // Автогенерация path для webp
    const getWebpPath = (path) => {
        if (!path) return "";
        if (withoutWebp) return path;
        return path.replace(/\.(jpg|jpeg|png)$/i, ".webp");
    };

    if (!srcMobile) {
        srcMobile = src;
    }

    const webp = getWebpPath(src);
    const webpMobile = getWebpPath(srcMobile);

    return (
        <picture className={classNames("picture", className)} onClick={onClick}>
            {srcMobile && (
                <source type="image/webp" srcSet={webpMobile} media="(max-width: 767px)" />
            )}
            {src && (
                <source type="image/webp" srcSet={webp} media="(min-width: 768px)" />
            )}
            {srcMobile && (
                <source srcSet={srcMobile} media="(max-width: 767px)" />
            )}
            <img
                src={src}
                alt={alt}
                title={title ?? alt}
                width={width}
                height={height}
                className={classNames("image", imageClassName)}
                loading={loading}
                draggable={draggable}
            />
        </picture>
    );
}

export default Picture;
